export default class FileTooLargeError {}
